$('.preview-btn').off('click').click(require('./../functions/preview_button.js'));
setTimeout(require('./../functions/replace_preview_button.js'), 500);
